import React from 'react';
import { Accordion, Divider, Typography } from '@mui/material';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { arrayOf, instanceOf, number, shape, string } from 'prop-types';

import { getSelectedSignalsByGroup } from '../../../../util';
import { SignalsAccordionDetails, SignalsAccordionSummary } from '../../styles';
import { GroupSignalCounter } from '../../../../../../../../../../components/SignalSelection/styles';

const SignalsList = ({
  title,
  signals,
  selectedSignals,
  selectedSignalCount,
}) => {
  const selectedSignalsByGroup = getSelectedSignalsByGroup(signals, selectedSignals);

  return (
    <Accordion className="icon-right" sx={{ '&:before': { top: '100%' } }}>
      <SignalsAccordionSummary
        expandIcon={<ExpandMoreRoundedIcon fontSize="small" />}
        aria-controls="signals-content"
        id="signals-header"
      >
        <Typography
          component="h2"
          variant="body2"
          sx={theme => ({
            fontFamily: theme.typography.bold.fontFamily,
            marginBottom: theme.spacing(1),
          })}
        >{title}
          <GroupSignalCounter>{`${selectedSignalCount} selected`}</GroupSignalCounter>
        </Typography>
      </SignalsAccordionSummary>
      <SignalsAccordionDetails>
        <ul>
          {Object.keys(selectedSignalsByGroup).map(groupName => (
            <li key={groupName}>
              <Typography key={groupName} variant="caption">{groupName}</Typography>
              <Divider sx={{ marginBottom: 2, marginTop: 1 }} />
              <ul>
                {selectedSignalsByGroup[groupName].map(({ name, description }) => {
                  const signalKey = `${groupName}.${name}`;
                  return (
                    <li key={signalKey}>
                      <Typography
                        variant="body2"
                        sx={theme => ({
                          fontFamily: theme.typography.bold.fontFamily,
                          marginBottom: theme.spacing(0.5),
                        })}
                      >{signalKey}
                      </Typography>
                      <Typography variant="caption" component="p" sx={{ marginBottom: 2 }}>{description}</Typography>
                    </li>
                  );
                })}
              </ul>
            </li>
          ))}
        </ul>
      </SignalsAccordionDetails>
    </Accordion>
  );
};

export default SignalsList;

SignalsList.propTypes = {
  title: string.isRequired,
  signals: shape({
    [string]: arrayOf(shape({
      name: string.isRequired,
      groupName: string.isRequired,
      description: string.isRequired,
    })).isRequired,
  }).isRequired,
  selectedSignals: instanceOf(Set).isRequired,
  selectedSignalCount: number.isRequired,
};
